<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4001 16V8H17.6001V16H16.4001ZM12.4 15.2L11.55 14.35L13.3 12.6H6V11.4H13.3L11.55 9.65L12.4 8.8L15.6 12L12.4 15.2Z"
      fill="#383838"
    />
  </svg>
</template>
